import React from 'react'
import { Link } from 'react-router-dom'
import Buscador from '../../../../Reutilizables/buscador/Buscador'
import "../../../../../styles/servicios/contribuciones/menuContribuciones.css"

function MenuContribuciones() {
  return (
    <div className="navbar navbar-servi">

        <div className='first-link'>
          <Link to="/servicios" className='nav-link'>Servicios</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-contribuciones-participacion-plusvalia" className='nav-link'>Participación en plusvalia</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-contribuciones-transferencia-sector-electrico" className='nav-link'>Transferencia sector eléctrico</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-contribuciones-valorizacion-municipal" className='nav-link'>Valorización municipal</Link>
        </div>

        <div className='search search-servi search-servi-contribuciones'>
          <Buscador />
        </div>
        
      </div>
  )
}

export default MenuContribuciones